module.exports = __webpack_public_path__ + "images/fujian_banner02.jpg?45dfcfe67e284e6e70c7b5e58ff08013";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/fujian_banner02.jpg
// module id = 179
// module chunks = 1